import { normalizeCheckInStatus } from "../utils/optionNormalizers";

export const CHECK_IN_STATUS = {
  CHECKED_IN: "CHECKED_IN",
  NOT_CHECKED_IN: "NOT_CHECKED_IN",
};

export const CHECK_IN_STATUS_LABELS = {
  [CHECK_IN_STATUS.CHECKED_IN]: "Checked-In",
  [CHECK_IN_STATUS.NOT_CHECKED_IN]: "Not Checked-In",
};

export const CHECK_IN_STATUS_OPTIONS = [
  {
    value: CHECK_IN_STATUS.CHECKED_IN,
    label: CHECK_IN_STATUS_LABELS[CHECK_IN_STATUS.CHECKED_IN],
  },
  {
    value: CHECK_IN_STATUS.NOT_CHECKED_IN,
    label: CHECK_IN_STATUS_LABELS[CHECK_IN_STATUS.NOT_CHECKED_IN],
  },
];

export const isCheckedIn = (status) => {
  return normalizeCheckInStatus(status) === CHECK_IN_STATUS.CHECKED_IN;
};

export const isNotCheckedIn = (status) => {
  return normalizeCheckInStatus(status) === CHECK_IN_STATUS.NOT_CHECKED_IN;
};

export const getCheckInStatusLabel = (status) => {
  const normalizedStatus = normalizeCheckInStatus(status);
  return CHECK_IN_STATUS_LABELS[normalizedStatus] || status;
};

export const DEFAULT_CHECK_IN_STATUS = CHECK_IN_STATUS.NOT_CHECKED_IN;
